export enum DateFormat {
  FINRATE_STRING = 'FINRATE_STRING',
  DATE_OBJECT = 'DATE_OBJECT',
  ISO_OBJECT = 'ISO_OBJECT',
}

export enum MaterialDesignVersion {
  MATERIAL_1 = 1,
  MATERIAL_2_OUTLINE = 2,
  MATERIAL_2_BOX = 3,
}

export enum StyleModes {
  FINPACK_STYLE = 0,
  MORIZON_STYLE = 1
}
